import { ITag } from '@fluentui/react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { Button, FluentProvider, Label, webLightTheme } from '@fluentui/react-components';
import React from 'react';
import { IGenericFilterTag, ITypedTag } from '../../../utils/types/IGenericFilterTag';
import ValueTag from '../card/ValuteTag';

interface IGenericFilterTagItemsProps {
  filterTagItems: IGenericFilterTag[];
  onFilterTagsChange?: (
    filterTagKey: string,
    filterTagItems: ITag[],
    parentDataKey?: string,
  ) => void;
  onClearAllFilters: () => void;
}
const GenericFilterTagItems = (props: IGenericFilterTagItemsProps): JSX.Element => {
  const { filterTagItems, onFilterTagsChange, onClearAllFilters } = props;

  const emptyItems = filterTagItems.filter((tag: IGenericFilterTag) => {
    return tag.values?.length === 0;
  });

  if (emptyItems.length === filterTagItems.length) {
    return <></>;
  }

  return (
    <Stack horizontal wrap verticalAlign="center" tokens={{ childrenGap: 10 }}>
      {filterTagItems.map((tag: IGenericFilterTag): JSX.Element => {
        if (tag.values?.length > 0 && !tag.hideFromBar) {
          return (
            <Stack
              key={tag.dataKey}
              horizontal
              wrap
              verticalAlign="center"
              tokens={{ childrenGap: 10 }}
            >
              <Label style={{ fontWeight: 300 }}>{tag.title}</Label>

              {tag.values.map((filterValue: ITypedTag) => {
                return (
                  <ValueTag
                    key={filterValue.key}
                    tagString={filterValue.name}
                    iconName={filterValue?.isSavedFilter ? 'QueryList' : undefined}
                    onClick={(itemName: string) => {
                      onFilterTagsChange(
                        tag.dataKey,
                        tag.values.filter((t) => t.name !== itemName),
                      );
                    }}
                  />
                );
              })}
            </Stack>
          );
        }
        return <React.Fragment key={tag.dataKey} />;
      })}
      {!!filterTagItems?.length && (
        <FluentProvider theme={webLightTheme}>
          <Button appearance="transparent" onClick={onClearAllFilters}>
            Clear all
          </Button>
        </FluentProvider>
      )}
    </Stack>
  );
};
export default GenericFilterTagItems;
